import { firestoreAction } from 'vuexfire'
import db from '../firebase'

const state = {
  school: null,
  schoolFetched: false,
}
const getters = {
  school: (state) => {
    return state.school
  },
  schoolFetched: (state) => {
    return state.schoolFetched
  },
  schoolname: (state) => {
    return state.schools.map(schools => schools.name)
  }
}

const mutations={
  logout_school(state){
    //  ("Logga ut school")
    state.school=null;
    state.schoolFetched=false;
      }
}

const actions = {

  logoutSchool ({commit}) {
    commit('logout_school')
},

getSchool({state},schoolCode){
  db.collection('schools').where('code', '==', schoolCode).get().then(function (querySnapshot) {
    querySnapshot.forEach(function (doc) {
      const id = doc.id
      const output = doc.data()
      output.id=id;
      state.school=output;
    })
  })
},

saveSchool({},school){
  db.collection('schools').doc(school.id).update(school)
},



  initschool:
  firestoreAction(({ bindFirestoreRef }, schoolID) => {
    bindFirestoreRef('school', db.collection('schools').doc(schoolID)).then((res) => {
      //  (res)
      if(res==null)
    {  
      let p  = ""
      for (let i = 0; i <= 4; i++) {
        let element = Math.floor(Math.random() * 9+1); 
        p += element.toString();
      }
      
      db.collection('schools').doc(schoolID).set({name:"",code:p});
}
state.schoolFetched=true; 
// //console.log("init school"+ schoolID + state.schoolFetched)
// //console.log(res)
    })

  })
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
